<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
           
            <el-col :span="8">
              <el-form-item label="设备IMEI号" prop="deviceSerial">
                
                <el-input
                  clearable
                  disabled
                   v-model="form.deviceSerial"
                  
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备编号" prop="code">
                
                <el-input
                  clearable
                  disabled v-model="form.code"
                 
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="设备名称" prop="name"> 
  
  
                <el-input
                  clearable
                  disabled
                   v-model="form.name"
                  
                  maxlength="20"
                ></el-input> 
                
              </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item label="报废时间" prop="scrapTime">
              
              <el-date-picker
             
                v-model="form.scrapTime"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                style="width: 100%;"
                placeholder="请选择报废时间">
              </el-date-picker>
                      
            </el-form-item>
          </el-col>
            
            <el-col :span="8">
              <el-form-item label="报废人员" prop="scrapOperateUserName">
                
                <el-input
                  clearable
                   v-model="form.scrapOperateUserName"
               placeholder="请输入报废人员"
                  maxlength="20"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
           
            <el-col :span="24">
              <el-form-item label="报废说明" prop="scrapDesc">
                
                <el-input
           
             
              type="textarea"
              :rows="4"
              placeholder="请输入报废说明"
              maxlength="500"
              v-model="form.scrapDesc">
            </el-input>
                        
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right" v-if="model != 'view'">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
            提交
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
      </div>
    </div>
  </template>
    <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { getDictionary } from '@/api/common.js';
  import {getSmartDeviceDetail,smartDeviceScrap } from '@/api/nursingHome/artificalDevice';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
       
        form: {
          nursinghomeId: '',
          deviceSerial: '',
          name: '',
          code:"",
          scrapTime:'',
          scrapOperateUserId:'',
          scrapOperateUserName:'',
          scrapDesc:'',
        },
        formRules: {
          scrapTime: [{ required: true, message: '报废时间不能为空', trigger: 'change' }],
          scrapOperateUserName: [{ required: true, message: '报废人员不能为空', trigger: 'blur' }],
         
        },
        matetialList: [],
        deviceCategoryList: [],
        userList: [],
        deviceTypeIdList: [],
        deviceModelIdList: [],
        nursinghomeIdList: [],
        paymentTypeList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
     
    
       initData() {
        
        getSmartDeviceDetail({id: this.row.id}).then((res) => {
          this.form .deviceSerial= res.data.deviceSerial;
          this.form .code= res.data.code;
          this.form .name= res.data.name;
          this.form.id = res.data.id
        });
      },
      saveRecord() {
        this.$refs['formRef'].validate((valid) => {
            if (valid) {
              smartDeviceScrap(this.form).then((res) => {
                this.$message.success('提交成功');
                this.$emit('success');
              });
            }
          });
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
    <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
    